export default {
  namespaced: true,
  alarm: {
    alarm_id: "Alarm ID",
    description: "Descripción",
    title: "Alarma | Alarmas",
    folioCAD: "Folio CAD",
    statusCAD: "Status CAD",
    reaction_patrol: "Reaction patrol",
    alarm_type: "Tipo de alarma",
    status: "Estatus",
    attending: "En Atención",
    attended: "Atendidas",
    waiting: "En Espera",
    canceled: "Canceladas",
    all: "Todas",
    start_date_filter: "Fecha Inicio",
    end_date_filter: "Fecha Fin",
    date_filter: "Filtro de Fecha",
    dateRange: "Rango de días",
    dateRangeNone: "Ninguno",
    dateRangeLast30: "Últimos 30 días",
    dateRangeLast60: "Últimos 60 días",
    dateRangeHint: "Se calcula desde el momento en que se abre la vista de la alarma",
    new_alarms: "Nuevas alarmas",
    alarms: "Alarmas",
    dispatch: "Disparar",
    dispatchAlarm: "Disparar alarma",
    alarmCreated: "Alarma disparada correctamente",
    alarmError: "No se pudo disparar la alarma",
    noImagesInCarrousel: "No hay imágenes disponibles",
    loadingImage: "Cargando imagen...",
    imageNotAvailable: "Imagen no disponible",
    comment: "Comentario | Comentarios",
    type_alarm_not_found: "No se encontraron tipos de alarma",
    created_by: "creado por",
    timeline: {
      title: "Timeline",
      no_items: "No hay elementos en el timeline disponibles.",
      analytic_record: "Registro Analítico",
      comment: "Comentario",
      detection_event: "Evento de Detección",
      command_log: "Log de Comando",
      action_plans_logs: "Registros de Planes de Acción",
      unknown_command: "Comando Desconocido",
      camera: "Cámara",
      server: "Servidor",
      category: "Categoría",
      alarm_type: "Tipo de Alarma",
      priority: "Prioridad",
      matched_rules: "Reglas Coincidentes",
      record_info: "Registro: {to} de {total} eventos similares",
      event_info: "Evento: {to} de {total} detecciones similares",
      age: "Edad",
      glasses: "Gafas",
      yes: "Sí",
      no: "No",
      list: "Lista",
      emotion: "Emoción",
      score: "Puntuación",
      type: "Tipo",
      provider: "Proveedor",
      detection: "Detección",
      action: "Acción",
      target: "Objetivo",
      executed_by: "Ejecutado por",
      executed_by_system: "Ejecutado por el Sistema",
      user: "Usuario",
      command_type: "Tipo de Comando",
      command: "Comando",
      command_label: "Etiqueta del Comando",
      command_data: "Datos del Comando",
      ai_prompt: "Prompt de IA",
      ai_decision: "Decisión de IA",
      image: "Imagen",
      alarm_level: "Nivel de Alarma",
      user_id: "ID de Usuario",
      delay_time: "Tiempo de Retraso",
      dispatcher_info: "Información del Dispatcher",
      dispatcher_id: "ID del Dispatcher",
      source: "Fuente",
      workflow_id: "ID del Workflow",
      camera_round: "Ronda de Cámaras",
      name: "Nombre",
      cameras: "Cámaras",
      users: "Usuarios",
      location: "Ubicación",
      loop: "Bucle",
      radius: "Radio",
      layout: "Diseño",
      dispatcher_name: "Nombre del Dispatcher",
      alarm_id: "ID de Alarma",
      description: "Descripción",
      action_plan: "Plan de Acción",
      action_plans_logs: "Registros de Planes de Acción",
      alarm_bridge_device_logs: "Eventos del panel",
      instance: "Instancia",
      plan_id: "ID del Plan",
      duration: "Duración",
      step: "Paso",
      steps: "Pasos",
      decision: "Decisión",
      node: "Nodo",
      terminate: "Terminado",
      partial_terminate: "Parcialmente Terminado",
      question: "Pregunta",
      answer: "Respuesta",
      answer_options: "Opciones de Respuesta",
      required: "Requerido",
      executed: "Ejecutado",
      continue: "Continuar",
      outputs: "Salidas",
      data_types: "Tipos de Datos",
      filled_stack: "Stack Lleno",
      reason: "Razón",
      started_at: "Iniciado en",
      ended_at: "Finalizado en",
      command_data: "Datos del Comando",
      instance_uuid: "UUID de Instancia",
      seq: "Secuencia",
      files: "Archivos",
      comments: "Comentarios",
      cmd_id: "ID del Comando",
      cmd_name: "Nombre del Comando",
      created_at: "Creado en",
      source_timestamp: "Marca de Tiempo de Origen",
      user_info: "Información del Usuario",
      email: "Correo Electrónico",
      command: "Comando",
      information: "Información",
      full_name: "Nombre",
      soeid: "SOEID",
      alarm_workflow: 'Flujo de Alarma',
      TAKEN: 'El operador tomó la alarma',
      RELEASED: 'El operador liberó la alarma',
      SENT_TO_REVIEW: 'El operador envió la alarma a revisión',
      CHANGES_REQUESTED: 'El supervisor solicitó cambios a la alarma',
      SUPERVISOR_TAKEN_FROM_POOL: 'El supervisor tomó la alarma de la lista',
      OPERATOR_RESUMED_WORK: 'El operador abrió la alarma',
      COMPLETED: 'La alarma fue marcada como completada',
    },
    selected_alarms: "Alarmas seleccionadas",
    filters: "Filtros",
    type_alarm_categories: "Categorías de tipo de alarma",
    type_alarm_categories_placeholder: "Selecciona una categoría",
    select_options: "Seleccionar",
    remove_options: "Deseleccionar"
  },
};
